/* eslint-disable import/no-unresolved,camelcase */
import { Icon } from 'antd';
import React, { useState } from 'react';
import axios from 'axios';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../constants';

import '../css/svlist_styles.css'
const headers = { 'Content-Type': 'application/json' }

const SEARCH_URI = 'https://api.github.com/search/users';



const PcnSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 512 512" > <g>
    <path d="M499.085,295.157L368.99,264.546h-10.307c-6.457-42.074-38.248-75.915-79.258-85.402l-2.149-25.79h42.384v-15.631h-43.686
			l-4.776-57.313h-30.394l-4.776,57.313h-43.499v15.631h42.196l-2.149,25.79c-41.01,9.487-72.803,43.327-79.259,85.402h-10.306
			L12.915,295.157C5.31,296.946,0,303.651,0,311.463c0,9.236,7.514,16.75,16.751,16.75h40.365c-0.698,2.617-1.075,5.362-1.075,8.196
			c0,17.554,14.28,31.834,31.833,31.834c17.553,0,31.833-14.28,31.833-31.834c0-2.758-0.353-5.434-1.016-7.988h45.226
			c16.012,30.56,46.791,52.209,82.797,55.414v23.783h-15.631v15.631h47.935v-15.631h-16.673v-23.562
			c37.267-2.257,69.29-24.247,85.737-55.635h45.224c-0.663,2.554-1.016,5.23-1.016,7.988c0,17.554,14.28,31.834,31.833,31.834
			s31.833-14.28,31.833-31.834c0-2.833-0.377-5.579-1.075-8.196h40.366c9.237,0,16.751-7.514,16.751-16.75
			C512,303.651,506.689,296.946,499.085,295.157z M87.875,352.612c-8.934,0-16.202-7.269-16.202-16.203s7.268-16.202,16.202-16.202
			c8.934,0,16.202,7.268,16.202,16.202S96.809,352.612,87.875,352.612z M109.192,312.789L109.192,312.789
			c-5.647-5.102-13.125-8.214-21.316-8.214c-8.078,0-15.458,3.029-21.077,8.006H16.751c-0.618,0-1.12-0.501-1.12-1.119
			c0-0.522,0.354-0.971,0.864-1.09l128.329-30.196h7.291c0,0.064-0.002,0.127-0.002,0.191c0,2.846,0.12,5.666,0.346,8.454h-8.909
			v15.631h11.387c0.673,2.825,1.463,5.605,2.362,8.337H109.192z M255.186,96.04h1.629l1.477,17.715h-4.582L255.186,96.04z
			 M252.406,129.386h7.187l3.947,47.37c-2.492-0.179-5.005-0.275-7.541-0.275c-2.536,0-5.05,0.096-7.54,0.275L252.406,129.386z
			 M256.001,192.111c19.101,0,36.787,6.119,51.247,16.472H204.753C219.213,198.23,236.9,192.111,256.001,192.111z M187.962,224.214
			h136.074c9.488,11.475,16.109,25.391,18.826,40.64H169.137C171.854,249.605,178.474,235.69,187.962,224.214z M205.829,352.918
			c-22.96-15.926-38.043-42.443-38.082-72.433h59.598c-16.277,9.77-27.197,27.591-27.197,47.917
			C200.148,337.193,202.196,345.512,205.829,352.918z M295.342,336.757c-3.718,17.529-18.883,30.878-37.275,31.814
			c-0.69,0.016-1.373,0.052-2.067,0.052c-0.694,0-1.378-0.036-2.067-0.052c-18.391-0.936-33.557-14.286-37.275-31.814h7.132v-15.631
			h-7.338c3.436-18.713,19.857-32.943,39.548-32.943c19.692,0,36.113,14.229,39.548,32.943h-7.151v15.631H295.342z M306.169,352.919
			c3.634-7.406,5.681-15.725,5.681-24.516c0-20.328-10.919-38.147-27.197-47.917h59.598
			C344.212,310.475,329.129,336.992,306.169,352.919z M424.124,352.612c-8.934,0-16.202-7.269-16.202-16.203
			s7.268-16.202,16.202-16.202s16.202,7.268,16.202,16.202S433.059,352.612,424.124,352.612z M495.249,312.582h-50.048
			c-5.619-4.976-12.999-8.006-21.077-8.006c-8.192,0-15.668,3.112-21.316,8.214h-48.109c0.899-2.731,1.689-5.511,2.362-8.337h11.574
			v-15.631h-9.095c0.226-2.79,0.346-5.608,0.346-8.454c0-0.064-0.002-0.127-0.002-0.191h7.291l128.33,30.196
			c0.509,0.119,0.863,0.568,0.863,1.09C496.369,312.081,495.867,312.582,495.249,312.582z"/>
  </g>
  </svg>

);
const PcnIcon = props => <Icon component={PcnSvg} {...props} />


const SVKAiport = (props) => {

  const { onSearchOrgtxtFancy } = props

  //const { escountryOrg } = svfly_esquery_data

  const [isLoading, setIsLoading] = useState(false);

  const [selected, setSelected] = useState([]);
  const [kntas, setKntas] = useState([]);
  const [svorg, setSvorg] = useState('NN');


  const [options, setOptions] = useState([]);

  const handleSearch = (query) => {
    setIsLoading(true);
    const svairporturl = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/anautocomplete?keyword=${query}`


    const svairporturlBAse = `${SV_SOJ_ORCMOCK_ADDRESS}/shpoint/anautocomplete`

    const svq = `${encodeURIComponent(query)}`


    axios.get(svairporturlBAse, {
      headers: headers,
      validateStatus: false,
      params: {

        keyword: svq,

      }
    })
      .then((rs) => {

        const { data: { data } } = rs
        setKntas(data)
        setOptions(data);
        setIsLoading(false);
      });


  };

  const filterBy = () => true;
  const handleTa = (obOptionDataMulti) => {
    setSelected(selected);

    let obOptionData = obOptionDataMulti[0]
    if (obOptionData) {
      let mydepartureAirportCode = obOptionData.IATA


      onSearchOrgtxtFancy(obOptionData)

    }

  };
  return (

    <AsyncTypeahead
      filterBy={filterBy}
      id="async-exampleK"
      isLoading={isLoading}
      labelKey="NAME"
      minLength={3}

      onSearch={handleSearch}
      onChange={handleTa}

      options={kntas}
      placeholder="Search Port Enter city or country ..."
      renderMenuItemChildren={(option) => (
        <>
        

          <div className="p-container-talist">
           
            <div className="sp-container-talist-b2">
              <div className="svo-container-orglist">
                <div className="svo-box-orglist-b1">
                  <span style={{ fontSize: "27px" }} > <PcnIcon style={{ color: '#c67a37' }} type="shop" theme="filled" /></span><span style={{ fontSize: "23px", color: "f0d4b6", paddingLeft: "10px" }} className="o-span"> {option.IATA} </span>


                </div>
                <div className="svo-box-orglist-b1">
                  <span className="o-span">  {option["CITY"]} - {option.COUNTRY} </span>


                </div>
                <div className="svo-box-orglist-b2">
                        <span className="o-span">{option.NAME} </span>
                 </div>
                
              </div>
            </div>

          </div>

          <br />
        </>
      )}
    />
  );
};


export default SVKAiport;
